import { Select } from 'antd';
import React from 'react';

const hours = Array.from({ length: 24 }, (_, index) => ({
  value: index,
  label: index.toString().padStart(2, '0'),
}));

const minutes = Array.from({ length: 60 }, (_, index) => ({
  value: index,
  label: index.toString().padStart(2, '0'),
}));

function DurationInput({ value, onChange }) {
  const { hour, minute } = value ?? { hour: 0, minute: 0 };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <Select
        options={hours}
        placeholder="HH"
        value={hour || null}
        onChange={(value) => onChange({ minute, hour: value })}
      />
      <span>:</span>
      <Select
        options={minutes}
        placeholder="MM"
        value={minute || null}
        onChange={(value) => onChange({ minute: value, hour })}
      />
    </div>
  );
}

export { DurationInput };
